import React, { Component } from 'react';
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import Select from 'react-validation/build/select';
import TextArea from 'react-validation/build/textarea';
import SmallLoader from '../pieces/SmallLoader.js';
import axios from 'axios';

const required = (value) => {
  if (!value.toString().trim().length) {
    // We can return string or jsx as the 'error' prop for the validated Component
    return (<RequiredError/>);
  }
};
 
const email = (value) => {
  if (!value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
    return (<EmailError value={value}/>);
  } 
};

function RequiredError(){
  return (
    <label className="error input-error">This field is required.</label>
  )
}
function EmailError({...props}){
  return (
    <label className="error input-error">{props.value} is not a valid email.</label>
  )
}

class Contact extends Component {
  state = {
    
    formSubmitted: false,
    formSent: false,
    errors: false
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.form.validateAll();

    setTimeout(() => {
      window.scrollTo(500, 0);
      if(document.getElementsByClassName('input-error').length === 0){
        this.setState({ errors: false })
        this.sendFormData();
      }
      else {
        this.setState({ errors: true })
      }
     
    }, 10);
  }
  sendFormData = () => {
    var form = document.getElementById('contact-form');
    var formArray = [];
    var formString = '';
    for(var i = 0; i < form.elements.length; i++ ){
      var obj = {};
      obj.name = form.elements[i].name;
      obj.value = form.elements[i].value;
      
      formArray.push(obj);
      formString += `${form.elements[i].name}=${form.elements[i].value}&`;
    }

    this.setState({
      formSubmitted: true
    });

    axios.post(`http://www.andyyeosings.com/sendmessage.php?${formString}`)
      .then(function (response) {
        
        updateState();
      })
      .catch(function (error) {
        console.log(error);
      });

    var updateState = () => {
      this.setState({
        formSubmitted: false,
        formSent: true,
        errors: false
      });
    }
  }
  render(){

    return(
      <div className="general-content contact-content">
        <h2 className="content-headline no-margin">Contact</h2>
        
        <section className="content-block">
          {this.state.errors && !this.state.formSubmitted &&
            <p className="bold highlight"><label className="error">There were errors in this form. Please review and correct the indicated fields.</label></p>
          }
          
          {this.state.formSubmitted && 
          <SmallLoader/>
          }

          {!this.state.formSent && !this.state.formSubmitted &&
          
          <Form ref={c => { this.form = c }} noValidate="novalidate" id="contact-form" onSubmit={this.handleSubmit}> 
            <p>Please contact Andy for a booking or general inquiry by completing the form below:</p>

            <div className="input-row">
              <Input type="text" name="name" placeholder="Name *"  validations={[required]}/>
            </div>
            <div className="input-row">
              <Input type="text" name="email" placeholder="Email *"  validations={[required, email]}/>
            </div>
            <div className="input-row">
              <Select  name="subject" validations={[required]}>
                <option defaultValue>-- Subject -- *</option>
                <option value="Gig">Book me for a gig</option>
                <option value="General">General inquiry</option>
              </Select>
            </div>
            <div className="input-row">
              <TextArea name="message" placeholder="Your message" validations={[required]}></TextArea>
            </div>
            <div className="input-row">
              <button type="submit">Submit</button>
            </div>

          </Form>
          }
          
          { this.state.formSent &&
              <div className="form-success">
                <h3 className="no-margin content-heading">Thank you!</h3>
                <p>Your message has been sent to Andy. He will reply soon.</p>
              </div>
            }
        </section>
        

      </div>
    );
  }
}
export default Contact;


// WEBPACK FOOTER //
// ./src/modules/pages/Contact.js